// ==========================================================================
// Define modal callbacks here (initContent)
// ==========================================================================

import {
  fsGalleryCarousel,
  cardCarousel,
  windowGalleryCarousel,
} from './carousels';
import bindDateFields from './date-fields';
import { asyncForm } from './async-form';
//import modalController from './modal';
import { accordion } from './accordion';
import { onRender } from './helpers';
//import menuDisplay from './menu-display';

export const callbacks = {
  fsGalleryCarousel() {
    fsGalleryCarousel();
  },

  cardCarousel() {
    cardCarousel();
  },

  windowGalleryCarousel() {
    windowGalleryCarousel();
  },

  bindDateFields() {
    bindDateFields();
  },

  bindAsyncForm() {
    asyncForm.init();
    bindDateFields();
  },

  bindAccordion() {
    accordion.init();
  },

  openDirectionsMap() {
    alert('directions!');
  },

  // openDesktopDMN() {
  //   menuDisplay();
  //   import(/* webpackChunkName: "modal-cb-searchbar"*/ './searchbar').then(
  //     module => module.searchbar.modalSelect(),
  //   );
  // },

  // loginModal() {
  //   asyncForm.init();
  //   bindDateFields();
  //   const modalWindow = document.querySelector('.js-modal-window');
  //   modalWindow.classList.add('login-modal-temp');
  //   modalController.bindModals();
  // },

  asyncFormCallback(form, json) {
    const container = document.querySelector(
      form.getAttribute('data-container'),
    );
    const message = document.querySelector(
      form.getAttribute('data-message-container'),
    );
    const modalWindow = document.querySelector('.modal-window');

    if (json.error) {
      asyncForm.stopSpinner();
    }

    if (!json.new_modal) {
      if (json.html) {
        container.innerHTML = json.html;
      }
      if (!json.error) {
        if (json.redirect_url) {
          window.location.href = json.redirect_url;
        }
        if (json.form_message && message) {
          message.innerHTML = json.form_message;
          message.classList.add('has-success');
        }
      }
    } else {
      // modalController.removeContent('window');
      // modalController.addContent(json.html, 'window');
    }
    onRender(modalWindow, bindDateFields);
  },

  asyncFormTransferCallback(form, json) {
    callbacks.asyncFormCallback(form, json);
    if (!json.error && json.loyalty_points) {
      const pointsContainer = document.querySelector(
        form.getAttribute('data-loyalty-points-container'),
      );
      pointsContainer.innerHTML = json.loyalty_points;
    }
  },

  asyncFormInjectCallback(form, json) {
    callbacks.asyncFormCallback(form, json);
    if (!json.error && json.inject_html) {
      const injectContainer = document.querySelector(
        form.getAttribute('data-inject-container'),
      );
      injectContainer.innerHTML = json.inject_html;
    }
  },
};



// WEBPACK FOOTER //
// ./src/js/callbacks.js